import classnames from "classnames";
import React from "react";
import { REVEAL_SPOILER_BTN } from "./../../_shared/data-hooks.js";
import { Tooltip } from "./../../wix-rich-content-common/lib/tooltip.js";
import { SpoilerContainerIcon } from "../icons/spoiler-container-icon.js";
import { RevealButton } from "./reveal-button.js";
import { SpoilerDescriptionInput } from "./spoiler-description-input.js";
class SpoilerContainer extends React.Component {
  constructor() {
    super(...arguments);
    this.getReducedContainer = (className) => {
      const { onRevealSpoiler, pluginType, t } = this.props;
      const disabledRevealBtn = !onRevealSpoiler;
      const container = /* @__PURE__ */ React.createElement(
        SpoilerContainerIcon,
        {
          className,
          style: { cursor: !disabledRevealBtn ? "pointer" : "auto", display: "inline" },
          onClick: onRevealSpoiler,
          "data-hook": REVEAL_SPOILER_BTN
        }
      );
      return disabledRevealBtn ? container : /* @__PURE__ */ React.createElement(Tooltip, { content: t(`Spoiler_Reveal_${pluginType}_CTA`), hideArrow: true }, container);
    };
    this.getExpandedContainer = (containerClassName) => {
      const {
        description,
        buttonContent,
        pluginType,
        onRevealSpoiler,
        styles,
        setInPluginEditingMode,
        setFocusToBlock,
        handleButtonContentChange,
        isMobile,
        t
      } = this.props;
      const disabledRevealBtn = !onRevealSpoiler;
      const content = buttonContent ?? t(`Spoiler_Reveal_${pluginType}_CTA`);
      const buttonClassName = classnames(styles.revealSpoilerBtn, {
        [styles.revealSpoilerBtnMobile]: isMobile,
        [styles.onHoverBtn]: !disabledRevealBtn
      });
      return /* @__PURE__ */ React.createElement("div", { className: containerClassName, style: { width: "100%" } }, /* @__PURE__ */ React.createElement(
        SpoilerContainerIcon,
        {
          style: { cursor: !disabledRevealBtn ? "pointer" : "auto", display: "inline" },
          onClick: onRevealSpoiler
        }
      ), this.renderDescription(description), /* @__PURE__ */ React.createElement(
        RevealButton,
        {
          onRevealSpoiler,
          className: buttonClassName,
          value: content,
          onChange: handleButtonContentChange,
          setInPluginEditingMode,
          setFocusToBlock
        }
      ));
    };
  }
  renderDescription(description) {
    const {
      setInPluginEditingMode,
      pluginType,
      styles,
      handleDescriptionChange,
      setFocusToBlock,
      t
    } = this.props;
    return /* @__PURE__ */ React.createElement(
      SpoilerDescriptionInput,
      {
        setInPluginEditingMode,
        className: styles.spoilerDescription,
        value: description ?? t(`Spoiler_Reveal_${pluginType}_Placeholder`),
        onChange: handleDescriptionChange,
        setFocusToBlock
      }
    );
  }
  render() {
    const { pluginType, width, height, styles } = this.props;
    const containerClassName = pluginType === "Gallery" ? styles.spoilerContainer_Gallery : styles.spoilerContainer;
    const spoilerContainer = (width ?? Infinity) < 320 || (height ?? Infinity) < 228 ? this.getReducedContainer(containerClassName) : this.getExpandedContainer(containerClassName);
    return spoilerContainer;
  }
}
export {
  SpoilerContainer
};
//# sourceMappingURL=spoiler-container.js.map
